var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRestaurant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.416 10.76a1 1 0 001-1V2h-2v7.76a1 1 0 001 1M11.832 10.76a1 1 0 001-1V2h-2v7.76a1 1 0 001 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.124 14.64c2.901-.48 5.123-2.998 5.123-6.033V2h-2v6.607a4.128 4.128 0 01-4.123 4.123A4.128 4.128 0 016 8.607V2H4v6.607c0 3.035 2.222 5.555 5.124 6.034V30h2V14.64zM26.31 2.05c-.167-.057-1.68-.497-3.376.734-2.997 2.174-4.517 8.037-4.517 17.429a1 1 0 001 1h3.595v-2h-2.59c.13-10.5 2.305-13.753 3.618-14.758.357-.274.69-.411.96-.475V30h2V3a1 1 0 00-.69-.95"
  })))));
}

export default SvgIconRestaurant;